<app-icon [ngClass]="{hidden: !sectionId}" [type]="direction === 'up' ? iconTypes.chevronUp : iconTypes.chevronDown" size="3x" (click)="handleClick()">
</app-icon>